import { NgModule } from '@angular/core';
import { NgIf, NgForOf, CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconButton, MatButton } from '@angular/material/button';
import {
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatFormFieldModule, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { TranslationPipe } from '@shared/pipes/translation.pipe';
import { HeaderComponent } from './header/header.component';
import { SidenavMenuComponent } from './sidenav-menu/sidenav-menu.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { MfaSetupComponent } from './mfa-setup/mfa-setup.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SidenavMenuComponent,
    ChangePasswordComponent,
    MfaSetupComponent,
  ],
  exports: [HeaderComponent, SidenavMenuComponent],
  imports: [
    NgIf,
    MatListModule,
    NgForOf,
    RouterLink,
    RouterLinkActive,
    CommonModule,
    MatIconButton,
    MatButton,
    MatIcon,
    TranslationPipe,
    MatMenuModule,
    MatDialogTitle,
    MatDialogClose,
    LoaderComponent,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatError,
    MatInput,
  ],
})
export class LayoutModule {}
